import type { JSX } from 'react';

import { RecentSupportersList } from './components/RecentSupportersList';

export function RecentSupporters(): JSX.Element {
	return (
		<section
			className="flex max-h-[441px] min-h-fit w-full flex-col bg-background-base px-4 pb-0 pt-8 md:p-12 md:pb-0"
			data-qa="recent-supporters-module-new"
		>
			<RecentSupportersList />
		</section>
	);
}
